// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"65f07e72","271":"5175484b","3385":"65f07e72","4439":"65f07e72","6397":"252995db","7113":"65f07e72","7171":"5175484b","7714":"78262bde","8766":"252995db","9915":"65f07e72"}[chunkId] + ".chunk.css";
};